/* ==========================================================================
   SP-PDP-PROBE (16.10.2026) – Probe Canvas Board 244 (Schritt 3 „Soll“) + Board 245 (Stick-Check)
   17.10.2026 auf alle Produkte mit Konfigurator ausgerollt (snippets/sp-pdp-probe.liquid). Legt sich über sp-pdp-neu.js, sp-logo-preview.js,
   sp-logo-place.js und sp-pdp-de.js und baut Schritt 3 um (keine Logik doppelt: Klicks gehen an die
   vorhandenen Knöpfe/Felder). Abschalten zum Vergleich: ?probe=0 an die Adresse hängen.
   Board 244: Upload zuerst · Zonen-Karten Vorne/Hinten/Ärmel · ein Größenregler (ohne „Lage“) · Technik mit
     „je Stück“ · Druckfreigabe als eine Zeile · keine doppelten Vorne/Hinten-Minis · schwarze Preis-Leiste
     (Menge · Logo · Preis je Stück netto, Gesamt netto; ohne Menge Preis je Stück ab 1 Teil; per CSS ausgeblendet).
   Board 245: Stick-/Druck-Check im Browser beim Upload: Grün (passt), Gelb („Passt – mit Hinweis“, wir prüfen von Hand,
     blockiert nichts) oder Rot (so nicht) + Lösung. Regeln (Inhaber 17.10.2026, Einzelheiten bei evaluate()):
     Stick: Farben 1–3 · keine Verläufe · Linie grün ab 1 mm, gelb ab 0,8 mm · Schrift grün ab 8 mm, gelb ab 5,5 mm
     · Vollflächen erlaubt. Druck: grün ab 150 dpi, gelb ab 100 dpi · Linie grün ab 0,35 mm (1 pt), gelb ab 0,25 mm.
     Hintergrund: automatisch freistellen (nur Pixelbilder) oder „nicht mitsticken/-drucken“ – wir stellen frei.
     Ergebnis geht als Property „N. Logo Check“ (EN „Logo N check“) mit in den Warenkorb, dazu immer deutsch die
     versteckte Property „_N. Logo Check (Produktion)“ (Position, Datei, Technik, Breite, Hintergrund-Hinweis, Zeilen).
   CHECK V2 (17.10.2026, CSS: assets/sp-pdp-probe.css): Bild-Analyse aus dem Testlabor (118/118 Fälle; findBackground, Subpixel-Linienstärke,
     Schrift je Farbe, Innenflächen, Schatten) · Zahlen abgerundet (kein „nur bis 4 cm – gewählt 4 cm“) · Größer/Kleiner
     am Reglerraster und nur, wenn es danach passt · Ergebnis sofort neu bei Breitenänderung (Messwerte gemerkt) ·
     „noch in Prüfung“ statt altem Ergebnis im Warenkorb · Freistellen nur für Pixelbilder und nur für die noch
     gewählte Datei · „nicht mitsticken“ rückgängig machbar. Sicherung des Vorstands: assets/sp-pdp-probe-vor-check-v2.js
   ========================================================================== */
(function () {
  'use strict';
  if (/[?&]probe=0\b/.test(location.search)) return;

  var EN = /^en/i.test(document.documentElement.lang || '');
  function T(de, en) { return EN ? en : de; }
  var VAT = 1.19, MIN_DPI = 150;

  function eur(c) { return (c / 100).toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €'; }
  function mm(v) { return (Math.round(v * 10) / 10).toLocaleString('de-DE') + ' mm'; }
  function cm(v) { return (Math.round(v * 10) / 10).toLocaleString('de-DE') + ' cm'; }
  function num(v) { var n = parseFloat(String(v == null ? '' : v).replace(',', '.')); return isFinite(n) ? n : NaN; }
  function centsOf(t) { var m = /(\d{1,3}(?:[.\s]\d{3})*|\d+)[,.](\d{2})/.exec(String(t || '')); return m ? parseInt(m[1].replace(/[.\s]/g, ''), 10) * 100 + parseInt(m[2], 10) : 0; }
  function mk(tag, cls, html) { var d = document.createElement(tag); if (cls) d.className = cls; if (html != null) d.innerHTML = html; return d; }
  function esc(t) { return String(t == null ? '' : t).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function strip(t) { return String(t == null ? '' : t).replace(/<[^>]+>/g, ''); }
  function setText(el, t) { if (el && el.textContent !== t) el.textContent = t; }

  /* ---------------- Logo-Analyse (läuft komplett im Browser) ---------------- */
  var cache = new WeakMap(), measured = new WeakMap(), firstT = new WeakMap();
  function ext(f) { return String(f && f.name || '').split('.').pop().toLowerCase(); }
  function loadImage(url) {
    return new Promise(function (res, rej) { var im = new Image(); im.onload = function () { res(im); }; im.onerror = rej; im.src = url; });
  }
  /* PDF: pdf.js wird von sp-logo-preview.js nachgeladen – bis zu 8 s darauf warten statt sofort „nicht lesbar“.
     SVG/PDF mit eingebettetem Pixelbild werden markiert (embedded), die Auflösung prüfen wir dann von Hand. */
  function toCanvas(file) {
    var e = ext(file);
    if (e === 'ai' || e === 'eps') return Promise.resolve(null);
    if (e === 'pdf') {
      var waitPdf = function (n) {
        var L = window.pdfjsLib || window['pdfjs-dist/build/pdf'];
        if (L) return Promise.resolve(L);
        if (n <= 0) return Promise.reject(new Error('pdf.js'));
        return new Promise(function (res) { setTimeout(res, 200); }).then(function () { return waitPdf(n - 1); });
      };
      var lib;
      return waitPdf(40).then(function (L) { lib = L; return file.arrayBuffer(); })
        .then(function (b) { return lib.getDocument({ data: new Uint8Array(b) }).promise; })
        .then(function (pdf) { return pdf.getPage(1); }).then(function (pg) {
          var v0 = pg.getViewport({ scale: 1 }), sc = 1200 / Math.max(v0.width, v0.height), vp = pg.getViewport({ scale: sc });
          var c = document.createElement('canvas'); c.width = Math.round(vp.width); c.height = Math.round(vp.height);
          var ops = pg.getOperatorList ? pg.getOperatorList().catch(function () { return null; }) : Promise.resolve(null);
          return Promise.all([pg.render({ canvasContext: c.getContext('2d'), viewport: vp, background: 'rgba(0,0,0,0)' }).promise, ops]).then(function (r) {
            var O = lib.OPS || {}, emb = false, fa = r[1] && r[1].fnArray;
            if (fa) for (var i = 0; i < fa.length; i++) if (fa[i] === O.paintImageXObject || fa[i] === O.paintInlineImageXObject || fa[i] === O.paintImageXObjectRepeat) { emb = true; break; }
            return { c: c, vector: true, nativeScale: null, embedded: emb };
          });
        }).catch(function () { return null; });
    }
    var url = URL.createObjectURL(file);
    var svgText = e === 'svg' && file.text ? file.text().catch(function () { return ''; }) : Promise.resolve('');
    return Promise.all([loadImage(url), svgText]).then(function (r) {
      var im = r[0], vector = e === 'svg';
      var nw = im.naturalWidth || 1000, nh = im.naturalHeight || 1000;
      var MAX = 900, sc = vector ? MAX / Math.max(nw, nh) : Math.min(1, MAX / Math.max(nw, nh));
      var c = document.createElement('canvas'); c.width = Math.max(1, Math.round(nw * sc)); c.height = Math.max(1, Math.round(nh * sc));
      var x = c.getContext('2d'); x.imageSmoothingEnabled = true; x.imageSmoothingQuality = 'high';
      x.drawImage(im, 0, 0, c.width, c.height);
      URL.revokeObjectURL(url);
      return { c: c, vector: vector, nativeScale: vector ? null : nw / c.width, embedded: vector && /<image[\s>]/i.test(r[1]) };
    }).catch(function () { URL.revokeObjectURL(url); return null; });
  }

  /* Hintergrund finden (gemeinsam für measure und knockOut).
     Weißer Kasten = Rand des sichtbaren Inhalts (bei transparenten PNGs: Rand der deckenden Fläche) ist zu
     mind. 50 % fast weiß. Ein bis zu 3 px dünner Rahmen am Bildrand wird übersprungen (und mit entfernt).
     Randverbundenes Weiß wird geflutet; eingeschlossene weiße Flächen gelten als Hintergrund, wenn sie
     kompakt sind (Innenraum von O, A, B, e …), weiße Schrift/Formen auf Farbe bleiben (länglich).
     Rückgabe: { box, color:[r,g,b], mask (1 = Hintergrund), holes } */
  function findBackground(d, W, H) {
    var N = W * H, i, x, y, p, q, x0 = W, y0 = H, x1 = -1, y1 = -1;
    for (y = 0; y < H; y++) for (x = 0; x < W; x++) if (d[(y * W + x) * 4 + 3] > 12) { if (x < x0) x0 = x; if (x > x1) x1 = x; if (y < y0) y0 = y; if (y > y1) y1 = y; }
    var res = { box: false, color: null, mask: null, holes: 0 };
    if (x1 < 0) return res;
    function isWhite(p) { var k = p * 4; return d[k + 3] >= 100 && d[k] >= 226 && d[k + 1] >= 226 && d[k + 2] >= 226 && Math.max(d[k], d[k + 1], d[k + 2]) - Math.min(d[k], d[k + 1], d[k + 2]) <= 24; }
    function ring(k, fn) {
      var a = x0 + k, b = y0 + k, c = x1 - k, e = y1 - k, xx, yy;
      if (c - a < 8 || e - b < 8) return;
      for (xx = a; xx <= c; xx++) { fn(b * W + xx); fn(e * W + xx); }
      for (yy = b + 1; yy < e; yy++) { fn(yy * W + a); fn(yy * W + c); }
    }
    var inset = -1, k, n, wn, sr, sg, sb;
    for (k = 0; k <= 3 && inset < 0; k++) {
      n = 0; wn = 0;
      ring(k, function (p) { n++; if (isWhite(p)) wn++; });
      if (n && wn / n >= 0.5) {
        if (k > 0) {
          // nur überspringen, wenn die äußeren Ringe ein gleichmäßiger, nicht weißer Rahmen sind
          var m0 = [0, 0, 0], c0 = 0, same = 0;
          ring(0, function (p) { m0[0] += d[p * 4]; m0[1] += d[p * 4 + 1]; m0[2] += d[p * 4 + 2]; c0++; });
          m0 = [m0[0] / c0, m0[1] / c0, m0[2] / c0];
          ring(0, function (p) { if (d[p * 4 + 3] < 200 || Math.abs(d[p * 4] - m0[0]) + Math.abs(d[p * 4 + 1] - m0[1]) + Math.abs(d[p * 4 + 2] - m0[2]) < 60) same++; });
          if (same / c0 < 0.9) break;
        }
        inset = k;
      }
    }
    if (inset < 0) {
      // Regel B: alle vier Ecken weiß (z. B. Badge mit runden Ecken auf Weiß, Logo füllt den Rand fast aus)
      var cn = [y0 * W + x0, y0 * W + x1, y1 * W + x0, y1 * W + x1].filter(isWhite).length;
      if (cn < 4) return res;
      inset = 0;
    }
    var br = 0, bgg = 0, bb = 0, lum = -1;
    for (k = inset; k <= inset + 2; k++) {
      sr = 0; sg = 0; sb = 0; n = 0;
      ring(k, function (p) { if (isWhite(p)) { sr += d[p * 4]; sg += d[p * 4 + 1]; sb += d[p * 4 + 2]; n++; } });
      if (n && sr + sg + sb > lum * n) { lum = (sr + sg + sb) / n; br = sr / n; bgg = sg / n; bb = sb / n; }
    }
    var mask = new Uint8Array(N), st = new Int32Array(N), sp = 0;
    function near(p) { var k4 = p * 4; return d[k4 + 3] < 128 || Math.abs(d[k4] - br) + Math.abs(d[k4 + 1] - bgg) + Math.abs(d[k4 + 2] - bb) < 48 || isWhite(p); }
    // alles außerhalb des Rings (transparenter Rand, dünner Rahmen) ist Hintergrund
    for (y = 0; y < H; y++) for (x = 0; x < W; x++) if (x < x0 + inset || x > x1 - inset || y < y0 + inset || y > y1 - inset) mask[y * W + x] = 1;
    ring(inset, function (p) { if (!mask[p] && near(p)) { mask[p] = 1; st[sp++] = p; } });
    while (sp) {
      p = st[--sp]; x = p % W;
      q = p - 1; if (x > 0 && !mask[q] && near(q)) { mask[q] = 1; st[sp++] = q; }
      q = p + 1; if (x < W - 1 && !mask[q] && near(q)) { mask[q] = 1; st[sp++] = q; }
      q = p - W; if (q >= 0 && !mask[q] && near(q)) { mask[q] = 1; st[sp++] = q; }
      q = p + W; if (q < N && !mask[q] && near(q)) { mask[q] = 1; st[sp++] = q; }
    }
    var area = 0, opq = 0;
    for (i = 0; i < N; i++) if (d[i * 4 + 3] >= 128) { opq++; if (mask[i]) area++; }
    // nur ein paar weiße Pixel: kein Kasten · fast alles weiß: das Logo selbst ist weiß (z. B. weißes Logo auf transparent)
    if (area < 0.005 * opq || opq - area < Math.max(30, 0.002 * opq)) return res;
    // eingeschlossene weiße Flächen: kompakt = Innenraum (Hintergrund), länglich = gewollte weiße Schrift/Form
    var enc = new Uint8Array(N), D = new Uint16Array(N), v;
    for (i = 0; i < N; i++) if (!mask[i] && d[i * 4 + 3] >= 128 && near(i)) { enc[i] = 1; D[i] = 60000; }
    for (y = 0; y < H; y++) for (x = 0; x < W; x++) {
      p = y * W + x; if (!enc[p]) continue; v = D[p];
      v = Math.min(v, x > 0 ? D[p - 1] + 3 : 3, y > 0 ? D[p - W] + 3 : 3, x > 0 && y > 0 ? D[p - W - 1] + 4 : 4, x < W - 1 && y > 0 ? D[p - W + 1] + 4 : 4); D[p] = v;
    }
    for (y = H - 1; y >= 0; y--) for (x = W - 1; x >= 0; x--) {
      p = y * W + x; if (!enc[p]) continue; v = D[p];
      v = Math.min(v, x < W - 1 ? D[p + 1] + 3 : 3, y < H - 1 ? D[p + W] + 3 : 3, x < W - 1 && y < H - 1 ? D[p + W + 1] + 4 : 4, x > 0 && y < H - 1 ? D[p + W - 1] + 4 : 4); D[p] = v;
    }
    var lab = new Int32Array(N), comp = [], id = 0;
    for (i = 0; i < N; i++) {
      if (!enc[i] || lab[i]) continue;
      id++; var a = 0, mx = 0; sp = 0; st[sp++] = i; lab[i] = id;
      while (sp) {
        p = st[--sp]; a++; if (D[p] > mx) mx = D[p]; x = p % W;
        q = p - 1; if (x > 0 && enc[q] && !lab[q]) { lab[q] = id; st[sp++] = q; }
        q = p + 1; if (x < W - 1 && enc[q] && !lab[q]) { lab[q] = id; st[sp++] = q; }
        q = p - W; if (q >= 0 && enc[q] && !lab[q]) { lab[q] = id; st[sp++] = q; }
        q = p + W; if (q < N && enc[q] && !lab[q]) { lab[q] = id; st[sp++] = q; }
      }
      var r = mx / 3; // Radius des größten Innenkreises (px)
      comp[id] = a <= 2.6 * Math.PI * r * r + 6;
    }
    for (i = 0; i < N; i++) if (lab[i] && comp[lab[i]]) { mask[i] = 1; res.holes++; }
    res.box = true; res.color = [br, bgg, bb]; res.mask = mask;
    return res;
  }

  function measure(r) {
    var c = r.c, W = c.width, H = c.height, N = W * H;
    var d = c.getContext('2d', { willReadFrequently: true }).getImageData(0, 0, W, H).data;
    var i, k, p, q, x, y, v, transp = 0;
    for (i = 0; i < N; i++) if (d[i * 4 + 3] < 200) transp++;
    var bgr = findBackground(d, W, H), bgm = bgr.mask;
    var transparent = transp / N > 0.02 && !bgr.box;
    var fg = new Uint8Array(N), cnt = 0, x0 = W, y0 = H, x1 = -1, y1 = -1;
    for (i = 0; i < N; i++) {
      if (d[i * 4 + 3] >= 128 && !(bgm && bgm[i])) {
        fg[i] = 1; cnt++; x = i % W; y = (i / W) | 0;
        if (x < x0) x0 = x; if (x > x1) x1 = x; if (y < y0) y0 = y; if (y > y1) y1 = y;
      }
    }
    if (!cnt) return { na: true };
    var bw = x1 - x0 + 1, bh = y1 - y0 + 1;

    // ---- Farben: nur „ruhige“ Pixel (Kantenglättung und JPEG-Kanten zählen nicht) ----
    function dif(a, b) { a *= 4; b *= 4; return Math.abs(d[a] - d[b]) + Math.abs(d[a + 1] - d[b + 1]) + Math.abs(d[a + 2] - d[b + 2]); }
    var solid = new Uint8Array(N), sN = 0;
    for (y = 1; y < H - 1; y++) for (x = 1; x < W - 1; x++) {
      p = y * W + x;
      if (fg[p] && fg[p - 1] && fg[p + 1] && fg[p - W] && fg[p + W] && dif(p, p - 1) <= 30 && dif(p, p + 1) <= 30 && dif(p, p - W) <= 30 && dif(p, p + W) <= 30) { solid[p] = 1; sN++; }
    }
    var useAll = sN < 0.2 * cnt, base = useAll ? cnt : sN;
    var hc = new Int32Array(4096), hr = new Float64Array(4096), hg = new Float64Array(4096), hb = new Float64Array(4096), bin = new Int16Array(N);
    for (i = 0; i < N; i++) {
      if (!fg[i]) { bin[i] = -1; continue; }
      k = ((d[i * 4] >> 4) << 8) | ((d[i * 4 + 1] >> 4) << 4) | (d[i * 4 + 2] >> 4); bin[i] = k;
      if (useAll || solid[i]) { hc[k]++; hr[k] += d[i * 4]; hg[k] += d[i * 4 + 1]; hb[k] += d[i * 4 + 2]; }
      else if (!hc[k]) hc[k] = -1; // nur Kantenpixel in diesem Ton: braucht trotzdem eine Zuordnung
    }
    var used = [], tones = 0, allb = [];
    for (k = 0; k < 4096; k++) {
      if (hc[k] > 0) { used.push(k); allb.push(k); hr[k] /= hc[k]; hg[k] /= hc[k]; hb[k] /= hc[k]; if (hc[k] >= base * 0.001) tones++; }
      else if (hc[k] < 0) { allb.push(k); hc[k] = 0; hr[k] = ((k >> 8) & 15) * 16 + 8; hg[k] = ((k >> 4) & 15) * 16 + 8; hb[k] = (k & 15) * 16 + 8; }
    }
    used.sort(function (a, b) { return hc[b] - hc[a]; });
    var cen = [];
    for (i = 0; i < used.length && cen.length < 24; i++) {
      k = used[i]; if (hc[k] < base * 0.0008) break;
      var far = true;
      for (var j = 0; j < cen.length; j++) if (Math.abs(cen[j][0] - hr[k]) + Math.abs(cen[j][1] - hg[k]) + Math.abs(cen[j][2] - hb[k]) < 64) { far = false; break; }
      if (far) cen.push([hr[k], hg[k], hb[k]]);
    }
    if (!cen.length) cen.push([hr[used[0]], hg[used[0]], hb[used[0]]]);
    var bc = new Int8Array(4096), bd = new Float64Array(4096), it2, sums, ki;
    function assign(list) {
      list = list || used;
      for (var u = 0; u < list.length; u++) {
        var kk = list[u], best = 0, bdv = 1e9;
        for (var jj = 0; jj < cen.length; jj++) { var dd = Math.abs(cen[jj][0] - hr[kk]) + Math.abs(cen[jj][1] - hg[kk]) + Math.abs(cen[jj][2] - hb[kk]); if (dd < bdv) { bdv = dd; best = jj; } }
        bc[kk] = best; bd[kk] = bdv;
      }
    }
    for (it2 = 0; it2 < 3; it2++) {
      assign();
      sums = cen.map(function () { return [0, 0, 0, 0]; });
      for (i = 0; i < used.length; i++) { ki = used[i]; var s = sums[bc[ki]]; s[0] += hr[ki] * hc[ki]; s[1] += hg[ki] * hc[ki]; s[2] += hb[ki] * hc[ki]; s[3] += hc[ki]; }
      // nahe Zentren zusammenlegen, leere entfernen
      var nc = [];
      sums.forEach(function (s) {
        if (!s[3]) return;
        var m = [s[0] / s[3], s[1] / s[3], s[2] / s[3], s[3]];
        for (var z = 0; z < nc.length; z++) if (Math.abs(nc[z][0] - m[0]) + Math.abs(nc[z][1] - m[1]) + Math.abs(nc[z][2] - m[2]) < 50) {
          var t = nc[z][3] + m[3]; nc[z] = [(nc[z][0] * nc[z][3] + m[0] * m[3]) / t, (nc[z][1] * nc[z][3] + m[1] * m[3]) / t, (nc[z][2] * nc[z][3] + m[2] * m[3]) / t, t]; return;
        }
        nc.push(m);
      });
      cen = nc;
    }
    assign(allb);
    var share = cen.map(function () { return 0; }), dev = 0, farN = 0;
    for (i = 0; i < used.length; i++) { ki = used[i]; share[bc[ki]] += hc[ki]; dev += bd[ki] * hc[ki]; if (bd[ki] > 48) farN += hc[ki]; }
    dev /= base;
    var minPix = Math.max(12, Math.pow(bw * 0.01, 2)), colors = 0, cl = [];
    for (i = 0; i < cen.length; i++) { cen[i].s = share[i] / base; if (share[i] >= base * 0.001 && share[i] >= minPix) { colors++; cl.push({ r: cen[i][0], g: cen[i][1], b: cen[i][2], s: cen[i].s }); } }
    // weiche Transparenz (Schatten, Glühen): halbdurchsichtige Pixel, die nicht nur Kantenglättung sind
    var semi = 0;
    for (y = 1; y < H - 1; y++) for (x = 1; x < W - 1; x++) {
      p = y * W + x; if (bgm && bgm[p]) continue;
      var a0 = d[p * 4 + 3];
      if (a0 > 12 && a0 < 200) {
        var aL = d[(p - 1) * 4 + 3], aR = d[(p + 1) * 4 + 3], aU = d[(p - W) * 4 + 3], aD = d[(p + W) * 4 + 3];
        if (aL > 12 && aL < 200 && aR > 12 && aR < 200 && aU > 12 && aU < 200 && aD > 12 && aD < 200) semi++;
      }
    }
    var soft = semi > 0.03 * cnt;
    var gradient = soft || dev > 12 || farN / base > 0.08 || colors > 8;

    // ---- Bereiche je Farbe: Linienstärke und Schrift auch innerhalb farbiger Flächen ----
    var L = new Int8Array(N);
    for (i = 0; i < N; i++) L[i] = fg[i] ? bc[bin[i]] + 1 : 0;
    var cc = cen.map(function (z) { return [z[0], z[1], z[2]]; }), bgc = bgr.box ? bgr.color : null;
    function colOf(l) { return l > 0 ? cc[l - 1] : bgc; }
    // Zwischentöne an Farbgrenzen (Kantenglättung zwischen zwei Farben) der Nachbarfarbe zuschlagen
    function blendFix(step, lim) {
      for (var yy = 0; yy < H; yy++) for (var xx = 0; xx < W; xx++) {
        var pp = yy * W + xx, me = L[pp]; if (!me) continue;
        var aa = -1, b2 = -1, s1, s2;
        for (s1 = 1; s1 <= 3; s1++) { var c1 = step === 1 ? xx - s1 : yy - s1; if (c1 < 0) break; var q1 = pp - s1 * step; if (L[q1] !== me) { aa = L[q1]; break; } }
        if (aa < 0) continue;
        for (s2 = 1; s2 <= 3; s2++) { var c2 = step === 1 ? xx + s2 : yy + s2; if (c2 >= lim) break; var q2 = pp + s2 * step; if (L[q2] !== me) { b2 = L[q2]; break; } }
        if (b2 < 0 || aa === b2 || s1 + s2 > 4) continue;
        var A = colOf(aa), B = colOf(b2), k4 = pp * 4;
        if (!A || !B) {
          var M0 = cc[me - 1], C1 = A || B;
          if (s1 + s2 <= 3 && !solid[pp] && Math.abs(M0[0] - d[k4]) + Math.abs(M0[1] - d[k4 + 1]) + Math.abs(M0[2] - d[k4 + 2]) > 60 && Math.abs(C1[0] - d[k4]) + Math.abs(C1[1] - d[k4 + 1]) + Math.abs(C1[2] - d[k4 + 2]) < 160) L[pp] = A ? aa : b2;
          continue;
        }
        var vx = B[0] - A[0], vy = B[1] - A[1], vz = B[2] - A[2], ll = vx * vx + vy * vy + vz * vz; if (!ll) continue;
        var tt = ((d[k4] - A[0]) * vx + (d[k4 + 1] - A[1]) * vy + (d[k4 + 2] - A[2]) * vz) / ll; tt = Math.max(0, Math.min(1, tt));
        var ex = Math.abs(A[0] + tt * vx - d[k4]) + Math.abs(A[1] + tt * vy - d[k4 + 1]) + Math.abs(A[2] + tt * vz - d[k4 + 2]);
        if (ex < 48) { L[pp] = tt < 0.5 ? aa : b2; continue; }
        // schlecht passender Kantenpixel (JPEG-Ringing): zur ähnlicheren Nachbarfarbe, bei Hintergrund zur Farbseite
        var M = cc[me - 1], fit = Math.abs(M[0] - d[k4]) + Math.abs(M[1] - d[k4 + 1]) + Math.abs(M[2] - d[k4 + 2]);
        if (fit > 60 && s1 + s2 <= 3 && !solid[pp]) {
          if (aa === 0 || b2 === 0) L[pp] = aa === 0 ? b2 : aa;
          else { var dA = Math.abs(A[0] - d[k4]) + Math.abs(A[1] - d[k4 + 1]) + Math.abs(A[2] - d[k4 + 2]), dB = Math.abs(B[0] - d[k4]) + Math.abs(B[1] - d[k4 + 1]) + Math.abs(B[2] - d[k4 + 2]); L[pp] = dA <= dB ? aa : b2; }
        }
      }
    }
    if (gradient) { for (i = 0; i < N; i++) L[i] = fg[i] ? 1 : 0; } // Verlauf/Foto: Farbgrenzen sind keine Linien
    else { blendFix(1, W); blendFix(W, H); }
    // ---- Schrift: mind. 3 ähnlich hohe Teile auf einer Grundlinie (je Farbe, also auch weiße Schrift auf Farbe) ----
    var lab = new Int32Array(N), comps = [], stk = new Int32Array(N), sp;
    for (i = 0; i < N; i++) {
      if (!L[i] || lab[i]) continue;
      var idc = comps.length + 1, mnx = W, mny = H, mxx = -1, mxy = -1, area = 0, lc = L[i];
      sp = 0; stk[sp++] = i; lab[i] = idc;
      while (sp) {
        q = stk[--sp]; area++; x = q % W; y = (q / W) | 0;
        if (x < mnx) mnx = x; if (x > mxx) mxx = x; if (y < mny) mny = y; if (y > mxy) mxy = y;
        if (x > 0 && L[q - 1] === lc && !lab[q - 1]) { lab[q - 1] = idc; stk[sp++] = q - 1; }
        if (x < W - 1 && L[q + 1] === lc && !lab[q + 1]) { lab[q + 1] = idc; stk[sp++] = q + 1; }
        if (y > 0 && L[q - W] === lc && !lab[q - W]) { lab[q - W] = idc; stk[sp++] = q - W; }
        if (y < H - 1 && L[q + W] === lc && !lab[q + W]) { lab[q + W] = idc; stk[sp++] = q + W; }
      }
      comps.push({ x0: mnx, y0: mny, x1: mxx, y1: mxy, h: mxy - mny + 1, w: mxx - mnx + 1, a: area });
    }
    // Aufliegende Teile: ein Farbbereich, der ganz in EINER anderen Fläche liegt (z. B. weiße Schrift im Navy-Kreis),
    // wird beim Stick obenauf gestickt – die Fläche darunter läuft durch. Für deren Linienstärke zählen Lücken
    // zwischen den Buchstaben daher nicht als „feine Linie“.
    var nC = comps.length, nbs = [], out = new Uint8Array(nC + 1), par = new Int32Array(nC + 1);
    if (!gradient && nC < 5000) {
      for (i = 0; i <= nC; i++) nbs.push(null);
      var link = function (a, b) { if (!nbs[a]) nbs[a] = {}; nbs[a][b] = 1; };
      for (y = 0; y < H; y++) for (x = 0; x < W; x++) {
        q = y * W + x; var ca = lab[q]; if (!ca) continue;
        if (x === 0 || y === 0 || x === W - 1 || y === H - 1) out[ca] = 1;
        var r1 = x < W - 1 ? lab[q + 1] : -1, r2 = y < H - 1 ? lab[q + W] : -1;
        if (r1 === 0) out[ca] = 1; else if (r1 > 0 && r1 !== ca) { link(ca, r1); link(r1, ca); }
        if (r2 === 0) out[ca] = 1; else if (r2 > 0 && r2 !== ca) { link(ca, r2); link(r2, ca); }
        if (x > 0 && !lab[q - 1]) out[ca] = 1; if (y > 0 && !lab[q - W]) out[ca] = 1;
      }
      for (i = 1; i <= nC; i++) {
        if (out[i] || !nbs[i]) continue;
        var eff = Object.keys(nbs[i]).filter(function (b) { b = +b; var ks = nbs[b] ? Object.keys(nbs[b]) : []; return !(ks.length === 1 && +ks[0] === i && !out[b]); });
        // nur kleine Teile liegen auf (Schrift im Kreis); eine große Fläche innerhalb einer dünnen Kontur ist keine Auflage
        if (eff.length === 1 && comps[i - 1].a < comps[+eff[0] - 1].a) par[i] = +eff[0];
      }
    }
    // Abstandstransformation mit Kantenglättung (Subpixel): Startwert an jeder Grenze = Abstand der Pixelmitte zur
    // echten Kante, geschätzt aus Deckkraft bzw. Mischfarbe. Dann Chamfer (1 / √2). Ergebnis in px.
    // Zweimal: je Farbe (L) und mit aufliegenden Teilen in die Fläche darunter eingerechnet (L2).
    var SQ2 = Math.SQRT2;
    function covRel(pp, X, Y) {
      // Anteil von Pixel pp, der von Farbe X bedeckt ist, wenn die andere Seite Y ist (0 = Hintergrund)
      var k4 = pp * 4, al = d[k4 + 3] / 255, B = cc[X - 1], A = Y > 0 ? cc[Y - 1] : bgc;
      if (!A) return Y > 0 ? 1 : al; // transparent: Deckkraft
      var vx = B[0] - A[0], vy = B[1] - A[1], vz = B[2] - A[2], ll = vx * vx + vy * vy + vz * vz;
      var t = ll ? ((d[k4] - A[0]) * vx + (d[k4 + 1] - A[1]) * vy + (d[k4 + 2] - A[2]) * vz) / ll : 1;
      t = t < 0 ? 0 : t > 1 ? 1 : t;
      return Y > 0 ? t : Math.min(t, al);
    }
    function dtf(Lb, Dd) {
      var xx, yy, qq, vv, mm, sd, o, nbq = [-1, 1, -W, W];
      for (yy = 0; yy < H; yy++) for (xx = 0; xx < W; xx++) {
        qq = yy * W + xx; mm = Lb[qq]; if (!mm) { Dd[qq] = 0; continue; }
        sd = 1e9;
        if (xx === 0 || yy === 0 || xx === W - 1 || yy === H - 1) sd = 0.5;
        for (var z = 0; z < 4; z++) {
          if ((z === 0 && xx === 0) || (z === 1 && xx === W - 1) || (z === 2 && yy === 0) || (z === 3 && yy === H - 1)) continue;
          o = qq + nbq[z]; if (Lb[o] === mm) continue;
          var e = covRel(qq, mm, Lb[o]) - 0.5 + covRel(o, mm, Lb[o]);
          if (e < sd) sd = e;
        }
        Dd[qq] = sd < 0 ? 0 : sd;
      }
      for (yy = 0; yy < H; yy++) for (xx = 0; xx < W; xx++) {
        qq = yy * W + xx; mm = Lb[qq]; if (!mm) continue; vv = Dd[qq];
        if (xx > 0 && Lb[qq - 1] === mm && Dd[qq - 1] + 1 < vv) vv = Dd[qq - 1] + 1;
        if (yy > 0) {
          if (Lb[qq - W] === mm && Dd[qq - W] + 1 < vv) vv = Dd[qq - W] + 1;
          if (xx > 0 && Lb[qq - W - 1] === mm && Dd[qq - W - 1] + SQ2 < vv) vv = Dd[qq - W - 1] + SQ2;
          if (xx < W - 1 && Lb[qq - W + 1] === mm && Dd[qq - W + 1] + SQ2 < vv) vv = Dd[qq - W + 1] + SQ2;
        }
        Dd[qq] = vv;
      }
      for (yy = H - 1; yy >= 0; yy--) for (xx = W - 1; xx >= 0; xx--) {
        qq = yy * W + xx; mm = Lb[qq]; if (!mm) continue; vv = Dd[qq];
        if (xx < W - 1 && Lb[qq + 1] === mm && Dd[qq + 1] + 1 < vv) vv = Dd[qq + 1] + 1;
        if (yy < H - 1) {
          if (Lb[qq + W] === mm && Dd[qq + W] + 1 < vv) vv = Dd[qq + W] + 1;
          if (xx < W - 1 && Lb[qq + W + 1] === mm && Dd[qq + W + 1] + SQ2 < vv) vv = Dd[qq + W + 1] + SQ2;
          if (xx > 0 && Lb[qq + W - 1] === mm && Dd[qq + W - 1] + SQ2 < vv) vv = Dd[qq + W - 1] + SQ2;
        }
        Dd[qq] = vv;
      }
    }
    var Dt = new Float32Array(N), Dp = Dt, L2 = L, me2, hasPar = false;
    dtf(L, Dt);
    for (i = 1; i <= nC; i++) if (par[i]) { hasPar = true; break; }
    if (hasPar) {
      var root = new Int32Array(nC + 1), rootLab = new Int8Array(nC + 1);
      L2 = new Int8Array(N); Dp = new Float32Array(N);
      for (i = 1; i <= nC; i++) { var rt = i, guard = 0; while (par[rt] && guard++ < 20) rt = par[rt]; root[i] = rt; }
      for (i = 0; i < N; i++) if (lab[i] && root[lab[i]] === lab[i]) rootLab[lab[i]] = L[i];
      for (i = 0; i < N; i++) L2[i] = lab[i] ? rootLab[root[lab[i]]] : 0;
      dtf(L2, Dp);
    }
    // Grat (lokale Maxima, Toleranz 0,35 px) → Ketten ähnlicher Stärke. Stärke je Gratpunkt quer gemessen:
    // kleinste Summe der Abstände der beiden Nachbarn (waagrecht/senkrecht/diagonal) + Schrittweite.
    var ridge = new Uint8Array(N), wq = new Float32Array(N), maxD = 0, nb8 = [-W - 1, -W, -W + 1, -1, 1, W - 1, W, W + 1];
    var dirs = [[1, 1], [W, 1], [W + 1, SQ2], [W - 1, SQ2]];
    for (y = 1; y < H - 1; y++) for (x = 1; x < W - 1; x++) {
      q = y * W + x; if (!L[q]) continue;
      var useP = hasPar && !par[lab[q]], LL = useP ? L2 : L, DD = useP ? Dp : Dt;
      v = DD[q]; me2 = LL[q]; if (v > maxD) maxD = v;
      var isMax = true;
      for (k = 0; k < 8; k++) { var o = q + nb8[k]; if (LL[o] === me2 && DD[o] > v + 0.35) { isMax = false; break; } }
      // nur „echte“ Linienmitte: deckend und farblich passend (Kantenglättung, Weißsaum, JPEG-Ränder zählen nicht)
      if (isMax && !gradient) { var C2 = cc[L[q] - 1], k5 = q * 4; if (d[k5 + 3] < 200 || Math.abs(C2[0] - d[k5]) + Math.abs(C2[1] - d[k5 + 1]) + Math.abs(C2[2] - d[k5 + 2]) > 60) isMax = false; }
      if (!isMax) continue;
      ridge[q] = 1;
      var best = 1e9;
      for (k = 0; k < 4; k++) {
        var q1 = q - dirs[k][0], q2 = q + dirs[k][0];
        var d1 = LL[q1] === me2 ? DD[q1] : covRel(q1, me2, LL[q1]) - 0.5, d2 = LL[q2] === me2 ? DD[q2] : covRel(q2, me2, LL[q2]) - 0.5;
        var ww = d1 + d2 + 2 * dirs[k][1]; if (ww < best) best = ww;
      }
      wq[q] = best;
    }
    var seen = new Uint8Array(N), lineW = null;
    for (i = 0; i < N; i++) {
      if (!ridge[i] || seen[i]) continue;
      var vals = []; sp = 0; stk[sp++] = i; seen[i] = 1;
      while (sp) {
        q = stk[--sp]; vals.push(wq[q]);
        for (k = 0; k < 8; k++) {
          var o2 = q + nb8[k];
          if (o2 >= 0 && o2 < N && ridge[o2] && !seen[o2] && L[o2] === L[q] && Math.abs(wq[o2] - wq[q]) <= Math.max(1, wq[q] * 0.25)) { seen[o2] = 1; stk[sp++] = o2; }
        }
      }
      vals.sort(function (a, b) { return a - b; });
      var w20 = vals[Math.floor(vals.length * 0.2)], nlow = 0;
      for (k = 0; k < vals.length; k++) if (vals[k] <= w20 * 1.25) nlow++;
      if (nlow >= Math.max(6, w20) && (lineW === null || w20 < lineW)) lineW = w20;
    }
    var linePx = Math.max(0.5, lineW === null ? 2 * maxD : lineW);
    var cs = comps.filter(function (c) { return c.a >= 6 && c.h >= 3 && c.h < bh * 1.01 && c.w < bw * 0.9; }), textPx = null;
    if (cs.length <= 600) {
      cs.forEach(function (c) {
        var mates = cs.filter(function (o) {
          return o !== c && Math.abs(o.h - c.h) / c.h < 0.3 && Math.abs(o.y1 - c.y1) < 0.35 * c.h && Math.min(Math.abs(o.x0 - c.x1), Math.abs(c.x0 - o.x1)) < 2.5 * c.h;
        });
        if (mates.length < 2) return;
        var grp = mates.concat(c), hs = grp.map(function (o) { return o.h; }).sort(function (a, b) { return a - b; });
        var md = hs[hs.length >> 1];
        if (md >= bh * 0.9) {
          // Gruppe so hoch wie das ganze Logo: nur Schrift, wenn die Teile wie Buchstaben aussehen (nicht Kreise/Kästen)
          var fills = grp.map(function (o) { return o.a / (o.w * o.h); }).sort(function (a, b) { return a - b; });
          if (fills[fills.length >> 1] >= 0.72) return;
        }
        if (textPx === null || md < textPx) textPx = md;
      });
    }
    return {
      bw: bw, bh: bh, fill: cnt / (bw * bh), colors: Math.max(1, colors), gradient: gradient, soft: soft, tones: tones,
      transparent: transparent, box: bgr.box, holes: bgr.holes, linePx: linePx, textPx: textPx,
      vector: r.vector, embedded: !!r.embedded, nativeBw: r.nativeScale ? bw * r.nativeScale : null
    };
  }

  /* Analyse je Datei einmal (gecacht). Fehler beim Lesen oder Messen → { na: true } (Spinner hängt nie).
     Messwerte zusätzlich in „measured“, damit Breite/Technik ohne Spinner sofort neu bewertet werden. */
  function analyze(file) {
    if (cache.has(file)) return cache.get(file);
    firstT.set(file, Date.now());
    var p = toCanvas(file).then(function (r) {
      if (!r) return { na: true };
      return new Promise(function (res) { setTimeout(function () { try { res(measure(r) || { na: true }); } catch (e) { res({ na: true }); } }, 30); });
    }).catch(function () { return { na: true }; }).then(function (m) { measured.set(file, m); return m; });
    cache.set(file, p);
    return p;
  }

  /* Ergebnis für Technik + Breite – drei Stufen je Zeile (lv): 'ok' (grün), 'warn' (gelb: geht, wir prüfen von Hand), 'bad' (rot).
     Gesamt (status) = schlechteste Zeile. Gelb blockiert nichts. Regeln (Inhaber 17.10.2026):
       Stick: max. 3 Garnfarben, keine Verläufe · feinste Linie grün ab 1 mm, gelb 0,8–<1 mm, rot < 0,8 mm
              · kleinste Schrift (kleinster Buchstabe bzw. x-Höhe) grün ab 8 mm, gelb 5,5–<8 mm, rot < 5,5 mm
       Druck: Auflösung grün ab 150 dpi, gelb 100–149 dpi, rot < 100 dpi (bei gewählter Breite; Vektor ok)
              · feinste Linie grün ab 0,35 mm (1 pt), gelb 0,25–<0,35 mm, rot < 0,25 mm (Raster und Vektor)
       beide: weißer Hintergrund-Kasten rot, außer „nicht mitsticken/-drucken“ (dann grün mit Hinweis).
     Angezeigte Zahlen sind abgerundet (Linie Stick 0,1 mm, Linie Druck 0,01 mm, dpi ganz) und die Stufe richtet sich nach
     genau dieser Zahl – Text und Haken passen immer zusammen. Zahlen immer deutsch (auch unter /en/).
     Größer/Kleiner platzieren: Reglerraster (min + k·step, ≤ max); Ziel ist Grün für alle größenabhängigen Zeilen, sonst
     (nur wenn es jetzt rot ist) wenigstens Gelb – jeder Kandidat wird mit size() nachgeprüft. */
  function evaluate(m, fin, widthCm, maxCm, nb, minCm, stepCm) {
    if (!m || m.na) return { na: true };
    minCm = minCm > 0 ? minCm : 0;
    stepCm = stepCm > 0 ? stepCm : 0.5;
    var LV = { ok: 0, warn: 1, bad: 2 };
    function worst(a, b) { return LV[a] >= LV[b] ? a : b; }
    function lvOf(v, green, yellow) { return v >= green ? 'ok' : v >= yellow ? 'warn' : 'bad'; }
    function f1(v) { return Math.floor(v * 10 + 1e-6) / 10; }
    function f2(v) { return Math.floor(v * 100 + 1e-6) / 100; }
    function de(v) { return v.toLocaleString('de-DE'); }
    function mmF(v) { return de(v) + ' mm'; }
    function cmF(v) { return de(f1(v)) + ' cm'; }
    function rd(v) { return Math.round(v * 1000) / 1000; }
    var gMax = maxCm > 0 ? rd(minCm + Math.floor((maxCm - minCm) / stepCm + 1e-6) * stepCm) : Infinity, gMin = Math.max(minCm, 0.5);
    function gUp(v) { return rd(minCm + Math.max(0, Math.ceil((v - minCm) / stepCm - 1e-6)) * stepCm); }
    function gDn(v) { return rd(minCm + Math.floor((v - minCm) / stepCm + 1e-6) * stepCm); }
    var stick = fin === 'stick', rasterDpi = !stick && !m.vector && m.nativeBw > 0, printLine = !stick && !m.gradient;
    // größenabhängige Werte bei Breite w
    function size(w) {
      var px = w * 10 / m.bw, o = {};
      if (stick) {
        o.line = f1(m.linePx * px); o.lineLv = lvOf(o.line, 1, 0.8);
        o.text = m.textPx ? f1(m.textPx * px) : null; o.textLv = o.text === null ? 'ok' : lvOf(o.text, 8, 5.5);
        o.up = worst(o.lineLv, o.textLv); o.down = 'ok';
      } else {
        o.line = f2(m.linePx * px); o.lineLv = printLine ? lvOf(o.line, 0.35, 0.25) : 'ok';
        o.dpi = rasterDpi ? Math.floor(m.nativeBw / (w / 2.54) + 1e-6) : null; o.dpiLv = rasterDpi ? lvOf(o.dpi, 150, 100) : 'ok';
        o.up = o.lineLv; o.down = o.dpiLv; // Linie wird durch größer besser, Auflösung durch kleiner
      }
      o.lv = worst(o.up, o.down);
      return o;
    }
    var rows = [], fix = {};
    function row(lv, deTxt, enTxt, extra) {
      var r = { lv: lv, ok: lv === 'ok', t: T(deTxt, enTxt), de: deTxt };
      if (extra) for (var k in extra) if (extra.hasOwnProperty(k)) r[k] = extra[k];
      rows.push(r);
      return r;
    }
    var s0 = size(widthCm);
    if (stick) {
      if (m.gradient) row('bad', m.soft ? '<b>Schatten / weiche Transparenz erkannt</b> – lässt sich nicht sticken' : '<b>Farbverlauf / Foto erkannt</b> – lässt sich nicht sticken',
        m.soft ? '<b>Shadow / soft transparency detected</b> – can’t be embroidered' : '<b>Gradient / photo detected</b> – can’t be embroidered');
      else if (m.colors <= 3) row('ok', '<b>' + m.colors + (m.colors === 1 ? ' Farbe' : ' Farben') + '</b> – erlaubt sind bis zu 3 Garnfarben',
        '<b>' + m.colors + (m.colors === 1 ? ' colour' : ' colours') + '</b> – up to 3 thread colours allowed');
      else row('bad', '<b>' + m.colors + ' Farben</b> – erlaubt sind höchstens 3 Garnfarben', '<b>' + m.colors + ' colours</b> – max. 3 thread colours');
      if (s0.lineLv === 'ok') {
        if (s0.line >= 5) row('ok', '<b>Keine feinen Linien</b> – alle mind. 5 mm stark', '<b>No fine lines</b> – all at least 5 mm thick', { sz: 'line' });
        else row('ok', '<b>Feinste Linie ' + mmF(s0.line) + '</b> bei ' + cmF(widthCm) + ' Breite', '<b>Finest line ' + mmF(s0.line) + '</b> at ' + cmF(widthCm) + ' width', { sz: 'line' });
      } else if (s0.lineLv === 'warn') row('warn', '<b>Feine Linien</b> (feinste Linie ' + mmF(s0.line) + ') – wir prüfen das vor der Druckfreigabe von Hand',
        '<b>Fine lines</b> (finest line ' + mmF(s0.line) + ') – we’ll check this by hand before the print approval', { sz: 'line' });
      else row('bad', '<b>Feinste Linie ' + mmF(s0.line) + '</b> – zu fein für den Stick (mind. 0,8 mm, gut ab 1 mm)',
        '<b>Finest line ' + mmF(s0.line) + '</b> – too fine for embroidery (min. 0,8 mm, good from 1 mm)', { sz: 'line' });
      if (s0.text !== null) {
        if (s0.textLv === 'ok') row('ok', '<b>Kleinste Schrift ' + mmF(s0.text) + '</b> hoch', '<b>Smallest text ' + mmF(s0.text) + '</b> high', { sz: 'text' });
        else if (s0.textLv === 'warn') row('warn', '<b>Kleine Schrift ' + mmF(s0.text) + ' hoch</b> – wir prüfen die Lesbarkeit vor der Druckfreigabe von Hand',
          '<b>Small text ' + mmF(s0.text) + ' high</b> – we’ll check legibility by hand before the print approval', { sz: 'text' });
        else row('bad', '<b>Schrift nur ' + mmF(s0.text) + ' hoch</b> – zu klein für den Stick (mind. 5,5 mm, gut ab 8 mm)',
          '<b>Text only ' + mmF(s0.text) + ' high</b> – too small for embroidery (min. 5,5 mm, good from 8 mm)', { sz: 'text' });
      }
      if (m.box && nb) row('ok', '<b>Hintergrund wird nicht mitgestickt</b> – wir stellen ihn vor der Druckfreigabe frei', '<b>Background will not be stitched</b> – we remove it before the print approval', { nb: true });
      else if (m.box) row('bad', '<b>Weißer Hintergrund-Kasten</b> – würde mitgestickt', '<b>White background box</b> – would be stitched', { box: true });
      else if (!m.gradient && m.colors <= 3) row('ok', m.transparent ? 'Klare Flächen, Hintergrund transparent' : 'Klare Flächen, kein weißer Kasten', m.transparent ? 'Clean areas, transparent background' : 'Clean areas, no white box');
      fix.gradient = m.gradient || m.colors > 3;
    } else {
      if (m.vector && !m.embedded) row('ok', '<b>Vektordatei</b> – gestochen scharf in jeder Größe', '<b>Vector file</b> – sharp at any size');
      else if (m.vector) row('ok', '<b>Vektordatei mit eingebettetem Bild</b> – die Auflösung prüfen wir von Hand', '<b>Vector file with embedded image</b> – we’ll check the resolution by hand');
      else if (rasterDpi) {
        var maxPrint = m.nativeBw / MIN_DPI * 2.54;
        if (s0.dpiLv === 'ok') row('ok', '<b>Auflösung reicht</b> für Druck bis ' + cmF(maxPrint) + ' Breite', '<b>Resolution is fine</b> for print up to ' + cmF(maxPrint) + ' wide', { sz: 'dpi' });
        else if (s0.dpiLv === 'warn') row('warn', '<b>Druck möglich – Kanten wirken leicht weich</b> (' + de(s0.dpi) + ' dpi bei ' + cmF(widthCm) + '). Für beste Schärfe: größere Datei oder Vektor (SVG, PDF).',
          '<b>Printable – edges look slightly soft</b> (' + de(s0.dpi) + ' dpi at ' + cmF(widthCm) + '). For best sharpness: larger file or vector (SVG, PDF).', { sz: 'dpi' });
        else row('bad', '<b>Auflösung zu gering: ' + de(s0.dpi) + ' dpi</b> bei ' + cmF(widthCm) + ' – nötig sind mind. 100 dpi, gut ab 150 dpi (bis ' + cmF(maxPrint) + ')',
          '<b>Resolution too low: ' + de(s0.dpi) + ' dpi</b> at ' + cmF(widthCm) + ' – min. 100 dpi needed, good from 150 dpi (up to ' + cmF(maxPrint) + ')', { sz: 'dpi' });
      }
      if (printLine) {
        if (s0.lineLv === 'warn') row('warn', '<b>Sehr feine Linien</b> (feinste Linie ' + mmF(s0.line) + ') – wir prüfen das vor der Druckfreigabe von Hand',
          '<b>Very fine lines</b> (finest line ' + mmF(s0.line) + ') – we’ll check this by hand before the print approval', { sz: 'line' });
        else if (s0.lineLv === 'bad') row('bad', '<b>Linien zu fein für den Druck</b> – feinste Linie ' + mmF(s0.line) + ', mind. 0,35 mm (1 pt)',
          '<b>Lines too fine for print</b> – finest line ' + mmF(s0.line) + ', min. 0,35 mm (1 pt)', { sz: 'line' });
        else if (s0.line < 2) row('ok', '<b>Feinste Linie ' + mmF(s0.line) + '</b> – kräftig genug für den Druck (ab 0,35 mm)', '<b>Finest line ' + mmF(s0.line) + '</b> – strong enough for print (from 0,35 mm)', { sz: 'line' });
      }
      if (m.box && nb) row('ok', '<b>Hintergrund wird nicht mitgedruckt</b> – wir stellen ihn vor der Druckfreigabe frei', '<b>Background will not be printed</b> – we remove it before the print approval', { nb: true });
      else if (m.box) row('bad', '<b>Weißer Hintergrund-Kasten</b> – würde mitgedruckt', '<b>White background box</b> – would be printed', { box: true });
      else row('ok', m.transparent ? 'Hintergrund transparent' : 'Kein weißer Hintergrund-Kasten', m.transparent ? 'Transparent background' : 'No white background box');
    }
    // Größer / Kleiner platzieren: nächster Reglerwert in der Richtung, die hilft; Ziel Grün, sonst (bei Rot) Gelb
    function seek(dir, target) {
      var c = dir > 0 ? gUp(widthCm + 0.001) : gDn(widthCm - 0.001), n = 0;
      while (c <= gMax + 1e-9 && c >= gMin - 1e-9 && n++ < 400) { if (LV[size(c).lv] <= LV[target]) return c; c = rd(c + dir * stepCm); }
      return null;
    }
    var dir = s0.up !== 'ok' && s0.down === 'ok' ? 1 : s0.down !== 'ok' && s0.up === 'ok' ? -1 : 0;
    if (s0.lv !== 'ok') {
      var to = 'ok', w2 = dir ? seek(dir, 'ok') : null;
      if (w2 === null && dir && s0.lv === 'bad') { to = 'warn'; w2 = seek(dir, 'warn'); }
      var hint = s0.lv === 'bad'; // bei Gelb nur anbieten, wenn Grün erreichbar – kein Hinweis, wenn nicht
      if (dir > 0) fix.bigger = w2 !== null ? { need: w2, ok: true, lv: to, at: gMax } : (hint ? { need: null, ok: false, at: gMax } : null);
      if (dir < 0) { if (w2 !== null) { fix.smaller = w2; fix.smallerLv = to; } else if (hint) fix.noSmaller = true; }
      if (!dir && s0.lv === 'bad') fix.sizeConflict = true; // Druck: Linie verlangt größer, Auflösung kleiner
      if (!fix.bigger) delete fix.bigger;
    }
    var status = 'ok', nBad = 0;
    rows.forEach(function (r) { if (LV[r.lv] > LV[status]) status = r.lv; if (r.lv === 'bad') nBad++; });
    fix.boxOnly = !!(m.box && !nb && nBad === 1);
    return { status: status, ok: status === 'ok', rows: rows, fix: fix, box: !!(m.box && !nb), vector: !!m.vector };
  }

  /* Weißen Hintergrund entfernen → neue PNG-Datei (nur Pixelbilder; SVG/PDF bekommen nur „nicht mitsticken/-drucken“). Gleiche Hintergrund-Erkennung wie measure (Rahmen, Innenflächen,
     weiße Karte in transparentem PNG); Kante: Mischfarbe mit dem Hintergrund herausrechnen (bis 3 px tief, kein Saum). */
  function knockOut(file) {
    var url = URL.createObjectURL(file);
    return loadImage(url).then(function (im) {
      var nw = im.naturalWidth, nh = im.naturalHeight;
      if (!nw || !nh) { URL.revokeObjectURL(url); throw new Error('size'); }
      var sc = Math.min(1, 3000 / Math.max(nw, nh));
      var c = document.createElement('canvas'); c.width = Math.round(nw * sc); c.height = Math.round(nh * sc);
      var x = c.getContext('2d'); x.drawImage(im, 0, 0, c.width, c.height);
      var W = c.width, H = c.height, N = W * H, id = x.getImageData(0, 0, W, H), d = id.data, i, k, p, px, py;
      var bg = findBackground(d, W, H);
      if (bg.box) {
        var m = bg.mask, r0 = bg.color[0], g0 = bg.color[1], b0 = bg.color[2];
        // Abstand (in px, 8er-Nachbarschaft) zum entfernten Hintergrund, max. 3
        var dist = new Uint8Array(N), q = new Int32Array(N), qs = 0, qe = 0;
        for (i = 0; i < N; i++) if (m[i]) { dist[i] = 0; } else dist[i] = 255;
        for (i = 0; i < N; i++) if (m[i]) {
          px = i % W; py = (i / W) | 0;
          if ((px > 0 && !m[i - 1]) || (px < W - 1 && !m[i + 1]) || (py > 0 && !m[i - W]) || (py < H - 1 && !m[i + W])) q[qe++] = i;
        }
        while (qs < qe) {
          p = q[qs++]; px = p % W; py = (p / W) | 0; var dv = dist[p] + 1; if (dv > 3) continue;
          for (var dy = -1; dy <= 1; dy++) for (var dx = -1; dx <= 1; dx++) {
            var xx = px + dx, yy = py + dy; if (xx < 0 || yy < 0 || xx >= W || yy >= H) continue;
            var o = yy * W + xx; if (dist[o] > dv) { dist[o] = dv; q[qe++] = o; }
          }
        }
        var bgd = function (k4) { return Math.abs(d[k4] - r0) + Math.abs(d[k4 + 1] - g0) + Math.abs(d[k4 + 2] - b0); };
        var na = new Uint8Array(N), nr = new Uint8Array(N), ng = new Uint8Array(N), nbv = new Uint8Array(N), ch = new Uint8Array(N);
        for (i = 0; i < N; i++) {
          if (m[i] || dist[i] > 3) continue;
          px = i % W; py = (i / W) | 0;
          // Bezugsfarbe: am stärksten vom Hintergrund abweichender Logo-Pixel im 7×7-Fenster
          var ref = -1, rd = 0;
          for (var yy2 = Math.max(0, py - 3); yy2 <= Math.min(H - 1, py + 3); yy2++) for (var xx2 = Math.max(0, px - 3); xx2 <= Math.min(W - 1, px + 3); xx2++) {
            var o2 = yy2 * W + xx2; if (m[o2] || d[o2 * 4 + 3] < 128) continue; var dd = bgd(o2 * 4); if (dd > rd) { rd = dd; ref = o2 * 4; }
          }
          var q4 = i * 4, dp = bgd(q4);
          if (ref < 0 || rd < 30) continue;
          var a = Math.min(1, dp / rd);
          // nur echte Mischfarben (liegen auf der Linie Hintergrund → Logo-Farbe), andere Details bleiben
          var tR = r0 + (d[ref] - r0) * a, tG = g0 + (d[ref + 1] - g0) * a, tB = b0 + (d[ref + 2] - b0) * a;
          if (Math.abs(tR - d[q4]) + Math.abs(tG - d[q4 + 1]) + Math.abs(tB - d[q4 + 2]) > 60) continue;
          ch[i] = 1;
          if (a <= 0.06) { na[i] = 0; continue; }
          nr[i] = Math.max(0, Math.min(255, Math.round((d[q4] - r0 * (1 - a)) / a)));
          ng[i] = Math.max(0, Math.min(255, Math.round((d[q4 + 1] - g0 * (1 - a)) / a)));
          nbv[i] = Math.max(0, Math.min(255, Math.round((d[q4 + 2] - b0 * (1 - a)) / a)));
          na[i] = Math.round(d[q4 + 3] * a);
        }
        for (i = 0; i < N; i++) {
          k = i * 4;
          if (m[i]) d[k + 3] = 0;
          else if (ch[i]) { d[k + 3] = na[i]; if (na[i]) { d[k] = nr[i]; d[k + 1] = ng[i]; d[k + 2] = nbv[i]; } }
        }
      }
      x.putImageData(id, 0, 0);
      URL.revokeObjectURL(url);
      return new Promise(function (res, rej) {
        c.toBlob(function (b) {
          if (!b || !b.size) return rej(new Error('toBlob'));
          res(new File([b], String(file.name).replace(/\.[^.]+$/, '') + '-ohne-hintergrund.png', { type: 'image/png' }));
        }, 'image/png');
      });
    }, function (e) { URL.revokeObjectURL(url); throw e; });
  }

  /* ---------------- Seite umbauen ---------------- */
  function start(root) {
    var logosBox = root.querySelector('[data-spn-logos]');
    if (!logosBox) return;
    var step = logosBox.closest('.spn-step');
    var data = {}; try { data = JSON.parse(root.querySelector('[data-spn-data]').textContent); } catch (e) {}
    var vmap = {}; (data.variants || []).forEach(function (v) { vmap[v.color + '|' + v.size] = v; });
    root.classList.add('prb-on');
    var results = []; // je Logo: { ev | pending, fin, w, nb, file, key }
    var nobg = {};     // Datei-Schlüssel → Kunde will Hintergrund nicht mitsticken/-drucken
    var knocked = {};  // Datei-Schlüssel der freigestellten PNG → Name der Originaldatei
    var knocking = {}; // Datei-Schlüssel → Freistellen läuft gerade
    var knockFail = {}; // Datei-Schlüssel → Freistellen hat nicht geklappt
    function fkey(f) { return f ? [f.name, f.size, f.lastModified].join('|') : ''; }
    var busy = false, timer = 0;

    function st() { return root.spnState || { logos: [], sel: [], qty: {} }; }

    // Preis-Leiste
    var bar = mk('div', 'prb-bar');
    bar.innerHTML = '<div class="prb-bar__top"><span class="prb-bar__what"></span><span class="prb-bar__unit"><b></b><small></small></span></div>' +
      '<div class="prb-bar__tot"><span></span><b></b></div><p class="prb-bar__gross"></p>' +
      '<button type="button" class="prb-bar__btn"></button>' +
      '<p class="prb-bar__proof">✉ ' + T('Vor der Produktion bekommst du eine Druckfreigabe per E-Mail.', 'Before production you’ll receive a print approval by email.') + '</p>';
    bar.querySelector('.prb-bar__btn').textContent = (root.querySelector('[data-spn-add]') || {}).textContent || T('In den Warenkorb', 'Add to cart');
    bar.querySelector('.prb-bar__btn').addEventListener('click', function () { var b = root.querySelector('.spn-sum [data-spn-add]') || root.querySelector('[data-spn-add]'); if (b) b.click(); });

    // Positionsname wie angezeigt (unter /en/ übersetzt), sonst aus dem Zustand
    function pillLabel() {
      var p = logosBox.querySelector('.spn-logo .spn-pill[aria-pressed="true"]');
      var t = p && p.firstChild && p.firstChild.nodeType === 3 ? p.firstChild.textContent.trim() : '';
      return t || ((st().logos || [])[0] || {}).posLabel || '';
    }
    function updateBar() {
      var s = st(), pieces = 0, goods = 0, minP = null;
      (s.sel || []).forEach(function (n) {
        var q = (s.qty || {})[n] || {};
        (data.sizes || []).forEach(function (z) {
          var v = vmap[n + '|' + z]; if (!v) return;
          if (minP === null || v.price < minP) minP = v.price;
          if (q[z]) { pieces += q[z]; goods += q[z] * v.price; }
        });
      });
      if (minP === null) minP = Math.min.apply(null, (data.variants || [{ price: 0 }]).map(function (v) { return v.price; }));
      var per = centsOf((root.querySelector('[data-spn-fintotal]') || {}).textContent);
      var sub = pieces ? goods + pieces * per : minP + per, pct = 0;
      if (pieces) (data.tiers || []).forEach(function (t) { if (sub >= t.minCents) pct = t.pct; });
      var tot = Math.round(sub * (100 - pct) / 100), unit = pieces ? tot / pieces : tot;
      var lg = (s.logos || []), what;
      if (!lg.length) what = T('ohne Logo', 'no logo');
      else if (lg.length === 1) what = pillLabel() + ' · ' + (lg[0].fin === 'stick' ? T('Stick', 'Embroidery') : T('Druck', 'Print'));
      else what = lg.length + ' Logos';
      bar.querySelector('.prb-bar__what').innerHTML = '<b>' + (pieces ? pieces.toLocaleString('de-DE') + T(' Stück', ' pcs') : T('ab 1 Stück', 'from 1 pc')) + '</b> · ' + esc(what);
      setText(bar.querySelector('.prb-bar__unit b'), eur(unit / VAT));
      setText(bar.querySelector('.prb-bar__unit small'), T(' / Stk. netto', ' / pc net'));
      setText(bar.querySelector('.prb-bar__tot span'), pieces ? T('Gesamt netto', 'Total net') + (pct ? T(' · inkl. ' + pct + ' % Staffelrabatt', ' · incl. ' + pct + ' % volume discount') : '') : T('Trag in Schritt 2 deine Mengen ein', 'Enter your quantities in step 2'));
      setText(bar.querySelector('.prb-bar__tot b'), pieces ? eur(tot / VAT) : '');
      setText(bar.querySelector('.prb-bar__gross'), T('brutto ', 'gross ') + eur(unit) + T(' / Stk.', ' / pc') + (pieces ? ' · ' + eur(tot) + T(' gesamt', ' total') : '') + T(' · inkl. 19 % MwSt.', ' · incl. 19 % VAT'));
    }

    function sideOfPill(pill) { var line = pill.closest('.spn-posgrp__line'), t = line && line.querySelector('.spn-posgrp__t'); return t ? t.textContent.trim().toLowerCase() : ''; }
    function showSide(side) {
      var tg = document.querySelector('.splp-toggle'); if (!tg) return;
      var want = /hinten|back/.test(side) ? /hinten|back/i : (/ärmel|aermel|sleeve/.test(side) ? /ärmel|aermel|sleeve|arm/i : /vorne|front/i);
      Array.prototype.forEach.call(tg.querySelectorAll('button'), function (b) { if (want.test(b.textContent) && b.getAttribute('aria-pressed') !== 'true') b.click(); });
    }

    function card(c, i) {
      c.classList.add('prb-card');
      var head = c.querySelector('.spn-logo__head');
      var up = c.querySelector('label.spn-upl');
      var rows = Array.prototype.slice.call(c.querySelectorAll(':scope > .spn-lrow'));
      var tech = rows.filter(function (r) { return r.querySelector('.spn-seg'); })[0];
      var pos = rows.filter(function (r) { return r.querySelector('.spn-posgrp'); })[0];
      var split = rows.filter(function (r) { return r.querySelector('.spn-wbox'); })[0];
      var place = c.querySelector(':scope > .splpl');
      var proof = c.querySelector(':scope > .spn-proof');
      if (proof) proof.classList.add('prb-hide');
      if (split) split.classList.add('prb-hide');
      // Upload zuerst
      if (up) {
        var s = up.querySelector('strong'), sub = up.querySelector('.spn-upl__txt > span');
        if (s && /Logo-Datei wählen|Choose logo file/i.test(s.textContent)) setText(s, T('Logo hochladen – du siehst es sofort in der Vorschau', 'Upload your logo – see it in the preview right away'));
        setText(sub, T('PDF, AI, EPS, SVG oder PNG · bis 20 MB', 'PDF, AI, EPS, SVG or PNG · up to 20 MB'));
        up.classList.add('prb-upl');
      }
      var laterEl = c.querySelector(':scope > .prb-later');
      if (!laterEl) {
        laterEl = mk('p', 'prb-later');
        laterEl.addEventListener('click', function (e) { var b = e.target.closest('button'); if (!b) return; var lc = root.querySelector('[data-spn-latercheck]'); if (lc) lc.click(); });
      }
      var isLater = !!st().later;
      var lh = isLater ? T('Du schickst dein Logo nach der Bestellung per E-Mail. ', 'You’ll send your logo by email after ordering. ') + '<button type="button">' + T('Doch jetzt hochladen', 'Upload now instead') + '</button>'
        : T('Kein Logo zur Hand? ', 'No logo at hand? ') + '<button type="button">' + T('Später per E-Mail schicken', 'Send it later by email') + '</button>';
      if (laterEl.innerHTML !== lh) laterEl.innerHTML = lh;
      var chk = c.querySelector(':scope > .prb-chk') || mk('div', 'prb-chk');
      chk.dataset.i = i;
      // Position
      if (pos) {
        setText(pos.querySelector('.spn-label'), T('Wo soll es hin?', 'Where should it go?'));
        pos.classList.add('prb-pos');
      }
      // Größe
      if (place) {
        place.classList.add('prb-place');
        var lbl = place.querySelector('.splpl__lbl'); setText(lbl, T('Größe des Logos', 'Logo size'));
        var hasL = (data.sizes || []).indexOf('L') >= 0;
        var info = place.querySelector('.splpl__info'); setText(info, T('Oder im Bild an der Ecke ziehen.' + (hasL ? ' Maße für Größe L.' : ''), 'Or drag the corner in the image.' + (hasL ? ' Sizes refer to size L.' : '')));
      }
      // Technik
      if (tech) {
        Array.prototype.forEach.call(tech.querySelectorAll('.spn-seg__btn'), function (b) {
          var em = b.querySelector('em'), sp = b.querySelector(':scope > span:not(.spn-fin-ic)'), isStick = (b.getAttribute('data-fin') || '') === 'stick' || /stick|embroid/i.test(b.textContent);
          if (em && !/je Stück|per pc/.test(em.textContent)) em.textContent = em.textContent.trim() + T(' je Stück', ' per pc');
          setText(sp, isStick ? T('Stickdatei inklusive · bis 3 Garnfarben', 'Embroidery file included · up to 3 thread colours') : T('Fotos & Verläufe', 'Photos & gradients'));
        });
      }
      // Reihenfolge: Kopf, Upload, Später-Link, Check, Position, Größe, Technik
      var want = [head, up, laterEl, chk, pos, place, tech].filter(Boolean);
      var cur = Array.prototype.filter.call(c.children, function (n) { return want.indexOf(n) >= 0; });
      var same = cur.length === want.length && cur.every(function (n, k) { return n === want[k]; });
      if (!same) want.forEach(function (n) { c.appendChild(n); });
      return chk;
    }

    function rngOf(c) { return c && c.querySelector('.splpl__rng'); }
    function cardOf(i) { return logosBox.querySelectorAll(':scope > .spn-logo')[i] || null; }
    // gewählte Breite: Eingabe im Zustand, sonst Reglerstand (Standardbreite der Position), sonst 8 cm
    function widthOf(lg, rng) { var w = num(lg && lg.width); if (!(w > 0) && rng) w = num(rng.value); return w > 0 ? w : 8; }
    function isStickBtn(b) { return (b.getAttribute('data-fin') || '') === 'stick' || /stick|embroid/i.test(b.textContent); }
    function druckBtn(c) {
      if (!c) return null;
      return c.querySelector('.spn-seg__btn[data-fin="druck"]') || Array.prototype.filter.call(c.querySelectorAll('.spn-seg__btn'), function (b) { return !isStickBtn(b); })[0] || null;
    }
    var SYM = { ok: '✓', warn: '!', bad: '✕' }; // Zeilen-/Kopf-Symbol je Stufe (Stil: assets/sp-pdp-probe.css)

    function renderCheck(chk, i) {
      var s = st(), lg = (s.logos || [])[i], c = chk.closest('.spn-logo');
      if (!lg || s.later || !lg.file) { chk.hidden = true; chk.innerHTML = ''; chk.dataset.key = ''; results[i] = null; return; }
      var rng = rngOf(c), w = widthOf(lg, rng);
      var maxCm = rng ? num(rng.max) || 12 : 12, minCm = rng ? num(rng.min) || 0 : 0, stepCm = rng ? num(rng.step) || 0.5 : 0.5;
      var file = lg.file, fin = lg.fin, k = fkey(file), nb = !!nobg[k], kn = !!knocking[k], kf = !!knockFail[k];
      var key = [k, fin, w, maxCm, minCm, stepCm, nb ? 1 : 0, kn ? 1 : 0, kf ? 1 : 0].join('|');
      if (chk.dataset.key === key) return;
      chk.dataset.key = key; chk.hidden = false;
      var isStick = fin === 'stick';
      var base = { fin: fin, w: w, nb: nb, file: file, key: key };

      function show(m) {
        if (chk.dataset.key !== key || !chk.isConnected) return;
        var ev;
        try { ev = evaluate(m, fin, w, maxCm, nb, minCm, stepCm); } catch (e) { ev = { na: true }; }
        results[i] = { ev: ev, fin: fin, w: w, nb: nb, file: file, key: key };
        try { paint(ev); } catch (e) {
          results[i] = { ev: { na: true }, fin: fin, w: w, nb: nb, file: file, key: key };
          paintNa();
        }
      }
      function paintNa() {
        chk.className = 'prb-chk is-na';
        chk.innerHTML = '<div class="prb-chk__head"><span class="prb-chk__d">i</span><div><strong>' + T('Prüfen wir mit der Druckfreigabe', 'We’ll check it with the print approval') + '</strong><span>' +
          T('Diese Datei kann der Browser nicht prüfen. Wir schauen sie uns von Hand an.', 'Your browser can’t check this file. We’ll check it by hand.') + '</span></div></div>';
      }
      function paint(ev) {
        if (ev.na) { paintNa(); return; }
        var lvl = ev.status, good = lvl === 'ok', warn = lvl === 'warn', fx = ev.fix;
        var ttl = good ? (isStick ? T('Gut stickbar', 'Good for embroidery') : T('Gut druckbar', 'Good for print'))
          : warn ? T('Passt – mit Hinweis', 'OK – with a note')
          : (isStick ? T('So nicht stickbar', 'Not embroiderable like this') : T('So nicht gut druckbar', 'Not easy to print like this'));
        var bgNote = nb ? T(' Den Hintergrund stellen wir vor der Druckfreigabe frei.', ' We’ll remove the background before the print approval.') : '';
        var sub = good ? (nb ? T('Dein Logo passt.', 'Your logo works.') + bgNote : T('Dein Logo passt so, wie es ist.', 'Your logo works as it is.')) +
            (isStick ? T(' Die Stickdatei ist inklusive.', ' The embroidery file is included.') : '')
          : warn ? T('Du kannst so bestellen – die markierten Punkte prüfen wir vor der Druckfreigabe von Hand.', 'You can order like this – we’ll check the marked points by hand before the print approval.') + bgNote
          : T('Wähle eine Lösung – oder schick es so, dann melden wir uns vor der Druckfreigabe.', 'Pick a fix – or keep it, and we’ll contact you before the print approval.');
        var canKnock = ev.box && !ev.vector;
        if (fx.boxOnly) {
          ttl = T('Nur noch der Hintergrund', 'Just the background left');
          sub = canKnock ? T('Entferne ihn automatisch – oder wir stellen ihn für dich frei.', 'Remove it automatically – or we’ll remove it for you.')
            : (isStick ? T('Sag uns, dass er nicht mitgestickt wird – wir stellen ihn für dich frei.', 'Tell us not to stitch it – we’ll remove it for you.')
              : T('Sag uns, dass er nicht mitgedruckt wird – wir stellen ihn für dich frei.', 'Tell us not to print it – we’ll remove it for you.'));
        }
        var h = '<div class="prb-chk__head"><span class="prb-chk__d">' + SYM[lvl] + '</span><div><strong>' + ttl + '</strong><span>' + sub + '</span></div></div><ul>';
        ev.rows.forEach(function (r) {
          h += '<li class="' + r.lv + '"><span>' + SYM[r.lv] + '</span><span>' + r.t +
            (r.nb ? ' <button type="button" class="prb-undo" data-act="undo-nobg">' + T('rückgängig', 'undo') + '</button>' : '') + '</span></li>';
        });
        h += '</ul>';
        var notes = [], acts = '';
        // Größenknopf: Ziel Grün; nur bei Rot ersatzweise Gelb („dann mit Hinweis“)
        function sizeBtn(w, bigger, to) {
          return '<button type="button" class="prb-act" data-act="size" data-w="' + w + '">' + (bigger ? T('Größer platzieren', 'Place it larger') : T('Kleiner platzieren', 'Place it smaller')) +
            '<em>' + T('auf ' + cm(w), 'to ' + cm(w)) + (to === 'warn' ? T(' – dann mit Hinweis', ' – then with a note') : '') + '</em></button>';
        }
        if (warn) {
          // Gelb blockiert nichts: nur freiwillige Wege zu Grün
          if (fx.bigger && fx.bigger.ok) acts += sizeBtn(fx.bigger.need, true, fx.bigger.lv);
          if (fx.smaller) acts += sizeBtn(fx.smaller, false, fx.smallerLv);
        } else if (!good) {
          var techBtns = c ? c.querySelectorAll('.spn-seg__btn') : [], dBtn = druckBtn(c), pD = '', pS = '';
          Array.prototype.forEach.call(techBtns, function (b) { var em = b.querySelector('em'); if (!em) return; var net = '+' + eur(Math.round(centsOf(em.textContent) / VAT)); if (isStickBtn(b)) pS = net; else pD = net; });
          if (canKnock) {
            if (kn) acts += '<button type="button" class="prb-act is-p" data-act="knock" disabled>' + T('Hintergrund wird entfernt …', 'Removing background …') + '<em>' + T('einen Moment', 'one moment') + '</em></button>';
            else acts += '<button type="button" class="prb-act is-p" data-act="knock">' + T('Hintergrund entfernen', 'Remove background') + '<em>' + T('automatisch freistellen, dann neu prüfen', 'remove automatically, then re-check') + '</em></button>';
            if (kf) notes.push(T('Das automatische Entfernen hat nicht geklappt. Wähle „nicht mit' + (isStick ? 'sticken' : 'drucken') + '“ – dann stellen wir ihn für dich frei.',
              'Automatic removal didn’t work. Choose “don’t ' + (isStick ? 'stitch' : 'print') + '” – we’ll remove it for you.'));
          }
          if (ev.box) acts += '<button type="button" class="prb-act' + (canKnock ? '' : ' is-p') + '" data-act="nobg">' + (isStick ? T('Hintergrund nicht mitsticken', 'Don’t stitch the background') : T('Hintergrund nicht mitdrucken', 'Don’t print the background')) + '<em>' + T('wir stellen ihn für dich frei', 'we’ll remove it for you') + '</em></button>';
          if (isStick && dBtn && techBtns.length > 1 && !fx.boxOnly) acts += '<button type="button" class="prb-act' + (ev.box ? '' : ' is-p') + '" data-act="druck">' + T('Zu Digitaldruck wechseln', 'Switch to digital print') + '<em>' +
            (pD && pS ? esc(pD + T(' statt ', ' instead of ') + pS + T(' je Stück, netto', ' per pc, net')) : T('Fotos & Verläufe', 'Photos & gradients')) + '</em></button>';
          if (fx.bigger) {
            if (fx.bigger.ok) acts += sizeBtn(fx.bigger.need, true, fx.bigger.lv);
            else notes.push(T('Größer platzieren reicht hier nicht – auch bei max. ' + cm(fx.bigger.at) + ' bleibt es zu fein.', 'Placing it larger won’t do – even at max. ' + cm(fx.bigger.at) + ' it stays too fine.'));
          }
          if (fx.smaller) acts += sizeBtn(fx.smaller, false, fx.smallerLv);
          if (fx.smaller && fx.smallerLv === 'warn') notes.push(T('Für 150 dpi (scharfer Druck) ist die Datei zu klein – auf ' + cm(fx.smaller) + ' geht es mit leicht weichen Kanten.',
            'The file is too small for 150 dpi (sharp print) – at ' + cm(fx.smaller) + ' it works with slightly soft edges.'));
          if (fx.noSmaller) notes.push(T('Kleiner geht nicht – die kleinste Größe hier ist ' + cm(Math.max(minCm, 0.5)) + '. Lade eine größere Datei oder eine Vektordatei hoch.',
            'It can’t go smaller – the minimum size here is ' + cm(Math.max(minCm, 0.5)) + '. Upload a larger file or a vector file.'));
          if (fx.sizeConflict) notes.push(T('Größer macht die Auflösung schlechter, kleiner die Linien zu fein – lade eine größere Datei oder eine Vektordatei hoch.',
            'Larger lowers the resolution, smaller makes the lines too fine – upload a larger file or a vector file.'));
          var fileP = (fx.noSmaller || fx.sizeConflict) && !ev.box;
          if (!fx.boxOnly) acts += '<button type="button" class="prb-act' + (fileP ? ' is-p' : '') + '" data-act="file">' + T('Andere Datei hochladen', 'Upload a different file') + '<em>' +
            (isStick ? (fx.gradient ? T('z. B. einfarbige Version', 'e.g. single-colour version') : T('z. B. vereinfachte Version', 'e.g. simplified version'))
              : (fileP ? T('größere Datei oder Vektordatei', 'larger file or vector file') : T('z. B. Vektordatei (PDF, AI, SVG)', 'e.g. vector file (PDF, AI, SVG)'))) + '</em></button>';
        }
        if (acts) h += '<div class="prb-acts">' + acts + '</div>';
        notes.forEach(function (n) { h += '<p class="prb-chk__note">' + n + '</p>'; });
        chk.className = 'prb-chk is-' + lvl;
        chk.innerHTML = h;
      }

      // schon gemessen (Breite, Technik, Position, Hintergrund geändert): sofort neu bewerten, ohne Spinner
      if (measured.has(file)) { show(measured.get(file)); return; }
      results[i] = { pending: true, fin: fin, w: w, nb: nb, file: file, key: key };
      chk.className = 'prb-chk is-run';
      chk.innerHTML = '<p class="prb-chk__run">' + (isStick ? T('Wir prüfen dein Logo für den Stick …', 'Checking your logo for embroidery …') : T('Wir prüfen dein Logo für den Druck …', 'Checking your logo for print …')) + '</p><div class="prb-chk__bar"><i></i></div>';
      analyze(file).catch(function () { return { na: true }; }).then(function (m) {
        // Spinner beim ersten Upload mind. 700 ms (ab Beginn der Analyse), damit das Ergebnis nicht „flackert“
        setTimeout(function () { show(m); }, Math.max(0, 700 - (Date.now() - (firstT.get(file) || 0))));
      });
    }

    logosBox.addEventListener('click', function (e) {
      var pill = e.target.closest('.spn-pill');
      if (pill && !pill.disabled) { var sd = sideOfPill(pill); setTimeout(function () { showSide(sd); }, 60); }
      var a = e.target.closest('.prb-act, .prb-undo'); if (!a || a.disabled) return;
      var chk = a.closest('.prb-chk'), c = a.closest('.spn-logo'), i = +chk.dataset.i, lg = (st().logos || [])[i];
      var act = a.getAttribute('data-act');
      if (act === 'druck') { var b = druckBtn(c); if (b) b.click(); }
      else if (act === 'size') { var r = rngOf(c); if (r) { r.value = a.getAttribute('data-w'); r.dispatchEvent(new Event('input', { bubbles: true })); r.dispatchEvent(new Event('change', { bubbles: true })); } }
      else if (act === 'nobg' && lg && lg.file) { nobg[fkey(lg.file)] = 1; later(); }
      else if (act === 'undo-nobg' && lg && lg.file) { delete nobg[fkey(lg.file)]; later(); }
      else if (act === 'file') { var fi = c.querySelector('label.spn-upl input[type="file"]'); if (fi) fi.click(); }
      else if (act === 'knock' && lg && lg.file) {
        var src = lg.file, k = fkey(src);
        if (knocking[k]) return;
        knocking[k] = 1; delete knockFail[k]; a.disabled = true; later();
        knockOut(src).then(function (f) {
          delete knocking[k];
          // nur einsetzen, wenn an diesem Logo noch dieselbe Datei gewählt ist (Kunde kann inzwischen gewechselt/entfernt haben)
          var s = st(), cur = (s.logos || [])[i], cc = cardOf(i), inp = cc && cc.querySelector('label.spn-upl input[type="file"]');
          if (!cur || cur.file !== src || s.later || !inp) { later(); return; }
          var dt = new DataTransfer(); dt.items.add(f); inp.files = dt.files;
          knocked[fkey(f)] = src.name;
          inp.dispatchEvent(new Event('change', { bubbles: true }));
        }).catch(function () { delete knocking[k]; knockFail[k] = 1; later(); });
      }
    });

    function apply() {
      if (busy) return; busy = true;
      try {
        var cards = logosBox.querySelectorAll(':scope > .spn-logo');
        if (results.length > cards.length) results.length = cards.length; // entferntes Logo: kein alter Check mehr im Warenkorb
        Array.prototype.forEach.call(cards, function (c, i) { var chk = card(c, i); renderCheck(chk, i); });
        var lc = step.querySelector('label.spn-check'); if (lc) lc.classList.add('prb-hide');
        var lt = step.querySelector('[data-spn-later]'); if (lt) lt.classList.add('prb-hide');
        var fin = step.querySelector('.spn-finline'); if (fin) fin.classList.add('prb-hide');
        var minis = step.querySelector('.splp-minis'); if (minis) minis.classList.add('prb-hide');
        if (bar.parentNode !== step || step.lastElementChild !== bar) step.appendChild(bar);
        updateBar();
      } finally { setTimeout(function () { busy = false; }, 0); }
    }
    function later() { clearTimeout(timer); timer = setTimeout(apply, 40); }
    new MutationObserver(function () { if (!busy) later(); }).observe(step, { childList: true, subtree: true, characterData: true });
    root.addEventListener('spn:change', later);
    root.addEventListener('input', later, true);
    root.addEventListener('click', function () { setTimeout(later, 30); }, true);
    apply();

    // Ergebnis als Line-Item-Property mitschicken: sichtbar in der Sprache des Kunden, versteckt (_) immer deutsch für die Produktion
    function props(s) {
      var out = {};
      s = s || st();
      if (s.later) return out;
      (s.logos || []).forEach(function (lg, i) {
        if (!lg || !lg.file) return;
        var k = fkey(lg.file), w = widthOf(lg, rngOf(cardOf(i))), r = results[i], isStick = lg.fin === 'stick', nb = !!nobg[k];
        var fresh = !!(r && r.ev && r.file === lg.file && r.fin === lg.fin && r.w === w && r.nb === nb);
        var de = [], vis = null;
        if (!fresh) { de.push('NOCH IN PRÜFUNG – bitte von Hand prüfen'); vis = T('Noch in Prüfung', 'Check still running'); }
        else if (r.ev.na) de.push('Von Hand prüfen – Datei konnte im Browser nicht geprüft werden');
        else {
          var amp = { ok: ['Grün', 'Green'], warn: ['Gelb', 'Yellow'], bad: ['Rot', 'Red'] }[r.ev.status];
          de.push(amp[0]);
          vis = T(amp[0], amp[1]) + ' · ' + (isStick ? T('Stick', 'Embroidery') : T('Druck', 'Print')) + ' ' + cm(w) + ' · ' +
            r.ev.rows.map(function (x) { return SYM[x.lv] + ' ' + strip(x.t); }).join('; ');
        }
        de.push((isStick ? 'Stick' : 'Druck') + ' ' + cm(w), 'Position: ' + (lg.posLabel || lg.pos || '–'), 'Datei: ' + lg.file.name);
        if (nb) de.push('HINTERGRUND NICHT ' + (isStick ? 'MITSTICKEN' : 'MITDRUCKEN') + ' – vor der Druckfreigabe freistellen');
        if (knocked[k]) de.push('Hintergrund automatisch entfernt (Original: ' + knocked[k] + ')');
        if (fresh && !r.ev.na) de.push(r.ev.rows.map(function (x) { return SYM[x.lv] + ' ' + strip(x.de); }).join('; '));
        out['_' + (i + 1) + '. Logo Check (Produktion)'] = de.join(' · ');
        if (vis) out[EN ? 'Logo ' + (i + 1) + ' check' : (i + 1) + '. Logo Check'] = vis;
      });
      return out;
    }
    (function hook(n) {
      var prev = root.spnExtraProps;
      if (typeof prev !== 'function' && n < 40) return setTimeout(function () { hook(n + 1); }, 250);
      root.spnExtraProps = function (s) {
        var out = {}; try { if (typeof prev === 'function') out = prev(s) || {}; } catch (e) {}
        try { var p = props(s); for (var key in p) if (p.hasOwnProperty(key)) out[key] = p[key]; } catch (e) {}
        return out;
      };
    })(0);
  }

  function boot() {
    var tries = 0;
    (function wait() {
      var root = document.querySelector('[data-spn-root]');
      if (root && root.spnState && root.querySelector('.spn-logo')) return start(root);
      if (++tries < 80) setTimeout(wait, 150);
    })();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();